'use client'
import React, { createContext, useContext } from 'react'

const ModuleViewContext = createContext({
    isDashboard: false,
    navigateToManager: () => { }
})

export const useModuleView = () => useContext(ModuleViewContext)

export const ModuleViewProvider = ({ isDashboard, navigateToManager, children }) => {
    return (
        <ModuleViewContext.Provider value={{ isDashboard, navigateToManager }}>
            {children}
        </ModuleViewContext.Provider>
    )
}
